import { createFileRoute, redirect } from '@tanstack/react-router'
import { ContributionRoomPage } from '../pages/ContributionRoomPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/contribution-room' as any)({
    component: ContributionRoomPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
